export default __webpack_public_path__ + "static/media/logo_actenzo.555b568a.png";